import { Component, OnInit, SimpleChanges, OnChanges, Input } from '@angular/core';
import { OrderService } from 'src/app/_services/dispo/order.service';
import { CustomerBranchService } from 'src/app/_services/dispo/customer-branch.service';
import { AbstractControl, FormControl, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TeamBaseService } from 'src/app/_services/dispo/team-base';
import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { TeamAbsenceService } from 'src/app/_services/dispo/team-absence.service';
import { DateAdapter } from '@angular/material/core';
import moment from 'moment';

@Component({
  selector: 'app-default-working-times',
  templateUrl: './default-working-times.component.html',
  styleUrls: ['./default-working-times.component.css']
})
export class DefaultWorkingTimesComponent implements OnInit {
  content: any;
  teamBaseData: any;
  teamForm: any;
  orderTypeList: any;
  customerBranchList: any;
  orderList: any;
  isNew: Boolean = false;
  addNew: Boolean = false;
  customer_id: any;
  submitted = false;
  teamAbsenceData: any;
  timeControl = new FormControl();
  companyList: any;
  showModal = true;
  absenceId: any;
  teamBaseId: any;
  start: any;
  end: any;
  defaultTimes: any = [];
  




  defaultTimesForm: FormGroup;

  
  constructor(
    private orderService: OrderService,
    private customerBranchService: CustomerBranchService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private teamBaseService: TeamBaseService,
    private teamAbsenceService: TeamAbsenceService,
    private router: Router,
    private route: ActivatedRoute, 
    private dateAdapter: DateAdapter<any>
  ) {
    this.dateAdapter.setLocale('de-DE');
   
    this.defaultTimesForm = this.fb.group({
      defaultTimes: this.fb.array(this.defaultTimes.map(day => this.createDayForm(day)))
    });

    // Automatisch die Stunden berechnen, wenn die Start- oder Endzeit geändert wird
    this.defaultTimesForm.get('defaultTimes').valueChanges.subscribe(value => {
      this.calculateHours();
    });
  }

  ngOnInit(): void {
    //const startDate = new Date();
    //const endDate = new Date();
    //this.start = this.range.get('start').setValue(startDate);
    //this.end = this.range.get('end').setValue(endDate);

    this.teamBaseId = this.route.snapshot.parent.parent.params.id;
    this.absenceId = this.route.snapshot.params.id;
     //get current movie data
     this.teamBaseService.getCurrentObject().subscribe( data => {
      this.teamBaseData = data;
      this.defaultTimes = data.teamBase.default_working_times;
      this.defaultTimesForm = this.fb.group({
        defaultTimes: this.fb.array(this.defaultTimes.map(day => this.createDayForm(day)))
      });
    },
    err => { this.content = JSON.parse(err.error).message;}
  );
     
  
    
  }

   // Erstellt die FormGroup für jeden Tag
   createDayForm(day): FormGroup {
    return this.fb.group({
      day: [day.day],
      default_start: [day.default_start],
      default_end: [day.default_end],
      hours: [day.hours],
      active: [day.active],
      note: [day.note]
    });
  }

  // Berechnung der Stunden
  calculateHours() {
    const timesArray = this.defaultTimesForm.get('defaultTimes') as FormArray;
    timesArray.controls.forEach(group => {
      const start = group.get('default_start').value;
      const end = group.get('default_end').value;
      if (start !== null && end !== null) {
        group.get('hours').setValue(end - start);
      } else {
        group.get('hours').setValue(0);
      }
    });
  }

  // Liefert den Namen des Tages (Montag, Dienstag, etc.)
  getDayName(index: number): string {
    const days = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
    return days[index];
  }

  // Form Submit
  submit() {
    console.log(this.defaultTimesForm.value.defaultTimes);
  }

  setForm(data) {
    this.teamForm = this.fb.group({
      id:                         data.id,
      team_base_id:               data.team_base_id || this.teamBaseId,
      absence_type:               'blocked',
      absence_type_id:            [data.absence_type_id,Validators.required],
      start_date:                 [data.start_date,Validators.required],
      end_date:                   [data.end_date,Validators.required],
      note:                       [data.note]  // Standardwert ist leer
    });
  }
  

  onSubmit() {
    this.submitted = true;
   
        //update
    this.teamBaseService.updateDefaultWorkingTimes(this.teamBaseData.teamBase.id, this.defaultTimesForm.value.defaultTimes).subscribe(
      data => {
        this.teamBaseData = data;
        this.toastr.success('Daten gepeichert!');
      },
      err => {
        this.toastr.warning(err.error.message, 'Ein Fehler ist aufgetreten');

      }
    );
   

  }

  goBack() {
    this.router.navigate(['../'],{ relativeTo: this.route }).then(() => {
      //window.location.reload();    
  });
    
    //this.router.navigateByUrl("/immo-details/' + id + '/immo-base");
  }

  onDialogClick(event: UIEvent) {
    // Capture click on dialog and prevent it from bubbling to the modal background.
    event.stopPropagation();
    event.cancelBubble = true;
  }

}
